import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import React from 'react';
import { ContainerValores } from './styles';
import LabelSp from '../LabelSp';
import { formatFloat } from '../../util/functions';

// import { Container } from './styles';

function ValoresContrato(props) {
  const { visible, setVisible, cliente } = props;

  const footer = (
    <div>
      <Button
        label="Fechar"
        icon="pi pi-times"
        onClick={() => {
          setVisible(false);
        }}
        className="p-button-danger"
      />
    </div>
  );

  let {
    edicaoPercAcessoAdicional,
    edicaoPercSalario,
    numeroDispositivos,
    edicaoQtdAcessoIncluso,
    modulosPercSalario,
    edicaoPercAcessoUltrapassado,
    percentualSalarioCalculado,
  } = cliente;
  edicaoPercAcessoAdicional = edicaoPercAcessoAdicional || 0;
  edicaoPercSalario = edicaoPercSalario || 0;
  numeroDispositivos = numeroDispositivos || 0;
  edicaoQtdAcessoIncluso = edicaoQtdAcessoIncluso || 0;
  modulosPercSalario = modulosPercSalario || 0;
  edicaoPercAcessoUltrapassado = edicaoPercAcessoUltrapassado || 0;
  percentualSalarioCalculado = percentualSalarioCalculado || 0;

  let edicaoQtdAcessoUltrapassado = numeroDispositivos - edicaoQtdAcessoIncluso;

  if (edicaoQtdAcessoUltrapassado < 0) {
    edicaoQtdAcessoUltrapassado = 0;
  }

  return (
    <ContainerValores>
      <Dialog
        closable={false}
        footer={footer}
        header="Valores do Contrato"
        visible={visible}
        style={{ minWidth: '350px', maxWidth: '800px', width: '95%' }}
        modal
        onHide={() => {
          setVisible(false);
        }}
      >
        <div className="p-grid">
          <div className="p-col-12 p-fluid titulo">
            <LabelSp>Dados da Edição</LabelSp>
          </div>

          <div className="div-edicao">
            <div className="div-edicao-item">
              <LabelSp>% Base</LabelSp>
              {formatFloat(edicaoPercSalario, 4)}
            </div>

            <div className="div-edicao-item">
              <LabelSp>Disp. Adicional</LabelSp>
              {formatFloat(edicaoPercAcessoAdicional, 4)}
            </div>

            <div className="div-edicao-item">
              <LabelSp>Disp. Incluso Edição</LabelSp>
              {edicaoQtdAcessoIncluso}
            </div>

            <div className="div-edicao-item">
              <LabelSp>Disp. Usado</LabelSp>
              {numeroDispositivos}
            </div>
          </div>

          <div className="p-col-12 p-fluid titulo" style={{ marginTop: 10 }}>
            <LabelSp>Dados dos Módulos</LabelSp>
          </div>
          <div className="div-modulos">{renderModulos(cliente.modulos)}</div>

          <div className="p-col-12 p-fluid titulo" style={{ marginTop: 10 }}>
            <LabelSp>Totais</LabelSp>
          </div>

          <div className="div-edicao">
            <div className="div-edicao-item">
              <LabelSp>% Edição Base</LabelSp>
              {formatFloat(edicaoPercSalario, 4)}
            </div>

            <div className="div-edicao-item">
              <LabelSp>% Módulos</LabelSp>
              {formatFloat(modulosPercSalario, 4)}
            </div>

            <div className="div-edicao-item">
              <LabelSp>% Subtotal</LabelSp>
              {formatFloat(modulosPercSalario + edicaoPercSalario, 4)}
            </div>

            <div className="div-edicao-item">
              <LabelSp>% Disp. Excedido</LabelSp>
              {formatFloat(edicaoPercAcessoUltrapassado, 4)}
            </div>

            <div className="div-edicao-item">
              <LabelSp>% Total</LabelSp>
              {formatFloat(percentualSalarioCalculado, 4)}
            </div>
          </div>
        </div>
      </Dialog>
    </ContainerValores>
  );

  function renderModulos(modulos) {
    if (!Array.isArray(modulos) || modulos.length === 0) {
      return <LabelSp>Sem módulos adicionais</LabelSp>;
    }

    return (
      <table>
        <thead>
          <tr>
            <th className="col-string">Nome</th>
            <th>% Módulo</th>
            <th>Qtd. Incluso</th>
            <th>Qtd Usado</th>
            <th>% Excedido</th>
          </tr>
        </thead>

        <tbody>
          {modulos.map(m => {
            let percExedido = 0;
            if (m.quantidade - m.qtdAcessoIncluso > 0) {
              percExedido = (m.quantidade - m.qtdAcessoIncluso) * m.percentual;
            }
            return (
              <tr key={m.id}>
                <td className="col-string">{m.modulo.descricao}</td>
                <td>{formatFloat(m.percentual, 4)}</td>
                <td>{m.qtdAcessoIncluso}</td>
                <td>{m.quantidade}</td>
                <td>{formatFloat(percExedido, 4)}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    );
  }
}

export default ValoresContrato;
